export const SET_TRUNKS = "SET_TRUNKS";
export const ADD_TRUNK_TO_LIST = "ADD_TRUNK_TO_LIST";
export const SET_TRUNK = "SET_TRUNK";
export const ADD_NEW_TRUNK = "ADD_NEW_TRUNK";
export const CLEAR_TRUNK = "CLEAR_TRUNK";
export const REMOVE_TRUNK = "REMOVE_TRUNK";
